//API.JS
import axios from "axios";
import { unstable_cache } from "next/cache";
import { addContentReference, addHubReference, addPageReference } from "../utils/fetch-all-data.js";
import https from 'https';
import { STRAPI_TAGS } from "./cache-tags.js";

// Never-expire server cache: revalidate:false means entries live forever and
// only renew when the Strapi webhook calls revalidateTag(). Impls throw so
// failures are never memoized.

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_STRAPI_API_URL,
  headers: {
    "Authorization": `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
    "Access-Control-Allow-Headers": "Content-Type, Authorization"
  }
});
// Create section with JWT token
//ENV Values in client side called be called here ... has to be passed tru..
export const postData = async (endpoint, data) => {
  // const baseURL = process.env.NEXT_PUBLIC_STRAPI_API_URL;
  const baseURL = 'https://cms.vxi.com/api/';
  const headers = {
    // "Authorization": `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
    "Authorization": `Bearer ec9e27d17fa7b3527d8b804daf9cbbc281c0d4482ec5436c231f514f69a0fbc1fab9a112eeb83ed0413087cf652147b9656ac6823e5bdf5a95c26daf1cd92c364be2de525d81d1534acc5fe38d0597fdffa1e812581a2603a151bc019eb31a19cc9336ff6cbb714d0a75c4179ea943fcf71ba2925cb8e0ca46702c7d9477602c`,
    "Content-Type": "application/json",
    // "Access-Control-Allow-Origin": "*",
    // "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
    // "Access-Control-Allow-Headers": "Content-Type, Authorization"
  }
  const res = await axios.post(
    `${baseURL}${endpoint}`,
    data,
    { headers }
  );
  return res.data;
};

// Full login + post flow
// export const handleSave = async () => {
//   const result = await postSection("Example Injection");
//   return result;
// };

// export const fetchPosts = async (endpoint) => {
//   let url = "";

//   switch (endpoint) {
//     case "contents":
//       // url = `/contents?populate[seo][populate]=shareImage&populate[section][populate]=leaders,leadersList,hero,button,images,announcements,announcements.images,floorPanel,floorPanel.images,metrics,vxi_contents,vxi_contents.vxiContent,vxi_contents.solutions,vxi_contents.industries,vxi_contents.section,vxi_contents.type,vxi_contents.vxiContent.author,vxi_contents.vxiContent.images,vxi_contents.vxiContent.supportImages,vxi_contents.vxiContent.author.authorImage,embeddeds,embedded,borderedItems,borderedItems.images,sliderList,sliderList.images,left,left.page,right,right.page,left.page.section.images,right.page.section.images&sort=id`;
//       url = `/contents?sort=id&populate[seo][populate]=shareImage&populate[section][populate][leaders][populate][leadersList][populate]=profile&populate[section][populate]=leaders,leadersList,hero,button,images,announcements,announcements.images,floorPanel,floorPanel.images,metrics,vxi_contents,vxi_contents.vxiContent,vxi_contents.solutions,vxi_contents.industries,vxi_contents.section,vxi_contents.type,vxi_contents.vxiContent.author,vxi_contents.vxiContent.images,vxi_contents.vxiContent.supportImages,vxi_contents.vxiContent.author.authorImage,embeddeds,embedded,borderedItems,borderedItems.images,sliderList,sliderList.images,left,left.page,right,right.page,left.page.section.images,right.page.section.images`;

//       break;

//     case "menus":
//       url = `/menus?populate[filteredSubMenuLink][populate]=filteredSubMenuLink&populate[sliderList][populate]=images&populate[vxiContent][populate]=vxiContent,vxiContent.author,vxiContent.preBuiltAuthor,solutions,industries,section,type,vxiContent.images,vxiContent.supportImages,vxiContent.author.authorImage&sort=id`;
//       break;

//     case "footer":
//       url = `/footer?populate=*`;
//       break;

//     case "vxi-contents":
//       url = `/vxi-contents?populate=*,seo,seo.shareImage,vxiContent,vxiContent.author,vxiContent.preBuiltAuthor,vxiContent.preBuiltAuthor.authorImage,vxiContent.customFields,solutions,industries,section,type,vxiContent.images,vxiContent.supportImages,vxiContent.author.authorImage,navigationSplit,navigationSplit.left,navigationSplit.right,navigationSplit.left.page,navigationSplit.right.page,navigationSplit.left.page.section.images,navigationSplit.right.page.section.images`;
//       break;

//     default:
//       url = `/${endpoint}?populate=*`;
//   }

//   return tryCatch(url);
// };
function buildStrapiQuery(params, prefix = '') {
  const query = new URLSearchParams();

  for (const key in params) {
    const value = params[key];
    const paramKey = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      const nested = buildStrapiQuery(value, paramKey);
      nested.forEach((v, k) => query.append(k, v));
    } else if (Array.isArray(value)) {
      value.forEach((v) => query.append(`${paramKey}[]`, v));
    } else {
      query.append(paramKey, value);
    }
  }

  return query;
}

export const fetchPostsImpl = async (endpoint) => {
  // let url = `/${endpoint}`;
  let url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}${endpoint}`;

  let params = { sort: "id" };

  switch (endpoint) {
    case "contents":
      params = {
        sort: "id",
        populate: {
          seo: {
            populate: ["shareImage"]
          },
          section: {
            populate: {
              leadersList: {
                populate: ["profile"]
              },
              hero: true,
              button: true,
              images: true,
              announcements: {
                populate: ["images"]
              },
              floorPanel: {
                populate: ["images"]
              },
              metrics: true,
              vxi_contents: {
                populate: {
                  vxiContent: {
                    populate: [
                      "author",
                      "images",
                      "supportImages",
                      "author.authorImage"
                    ]
                  },
                  solutions: true,
                  industries: true,
                  section: true,
                  type: true
                }
              },
              embeddeds: true,
              embedded: true,
              seriesArrangement: true,
              borderedItems: {
                populate: ["images"]
              },
              sliderList: {
                populate: ["images"]
              },
              left: {
                populate: {
                  page: {
                    populate: {
                      section: {
                        populate: ["images"]
                      }
                    }
                  }
                }
              },
              right: {
                populate: {
                  page: {
                    populate: {
                      section: {
                        populate: ["images"]
                      }
                    }
                  }
                }
              },
              cxa_hub: {
                populate: {
                  industries: true,
                  // SEO component with its metaSocial inside
                  seo: {
                    populate: {
                      shareImage: true,
                      metaSocial: {
                        populate: ["image"]
                      }
                    }
                  },
                  shareImage: true,
                  speaker: {
                    populate: ["authorImage"]
                  },
                  topics: true,
                  series: true
                }
              }
            }
          }
        }
      };
      break;

    case "menus":
      params = {
        sort: "id",
        populate: {
          filteredSubMenuLink: {
            populate: ["filteredSubMenuLink"]
          },
          sliderList: {
            populate: ["images"]
          },
          vxiContent: {
            populate: [
              "vxiContent",
              "vxiContent.author",
              "vxiContent.preBuiltAuthor",
              "solutions",
              "industries",
              "section",
              "type",
              "vxiContent.images",
              "vxiContent.supportImages",
              "vxiContent.author.authorImage"
            ]
          }
        }
      };
      break;

    case "footer":
      params = { populate: "*" };
      break;

    case "vxi-contents":
      // case "cxa-hubs":
      params = {
        fields: [
          "title",
          "hubSpotLink",
          "publishDate",
          "publishedAt",
          "public"
        ],
        populate: {
          "solutions": true,
          "industries": true,
          "section": true,
          "type": true,
          vxiContent: {
            fields: ["heroDescription"],
            populate: {
              images: true
            }
          },
          "updatedAt": true,
          "createdAt": true
        }
      };
      break;

    case "cxa-hubs":
      params = {
        populate: [
          "seo",
          "seo.shareImage",
          "speaker",
          "speaker.authorImage",
          "industries",
          "topics",
          "series",
        ]
      };
      break;

    default:
      params = { populate: "*" };
  }

  try {
    const { data } = await api.get(url, { params });
    return data?.data ?? data;
  } catch (error) {
    console.error("fetchPosts ERR ->", url, error?.response?.status, error?.response?.data || error.message);
    throw error; // do NOT cache failures
  }
};

export const fetchLegendsImpl = async (endpoint) => {
  let url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}${endpoint}`;

  const seo = {
    seo: {
      populate: "*"
    }
  };

  const vxiContentPopulate = {
    vxiContent: {
      fields: ["title"],
      populate: {
        solutions: true,
        industries: true,
        section: true,
        type: true,
        vxiContent: {
          fields: ["heroDescription"],
          populate: {
            images: true
          }
        }
      }
    }
  };

  let params = { sort: "id" };

  switch (endpoint) {
    case "contents":
      params = {
        sort: "id",
        fields: ["id", "title", "menuTitle", "subMenuTitle"],
        populate: seo
      };
      break;

    case "vxi-contents":
      params = {
        sort: "id",
        fields: ["id", "title", "publishDate", "public"],
        populate: {
          ...seo,
          section: {
            fields: ["id", "title"]
          },
          type: {
            fields: ["id", "title"]
          },
          industries: true,
          solutions: true,
        }
      };
      break;

    case "cxa-hubs":
      params = {
        populate: {
          ...seo,
          speaker: {
            populate: ["authorImage"]
          },
          industries: true,
          topics: true,
          series: true
        }
      };
      break;

    case "menus":
      params = {
        sort: "id",
        populate: {
          ...seo,
          filteredSubMenuLink: {
            populate: ["filteredSubMenuLink"]
          },
          sliderList: {
            populate: ["images"]
          },
          ...vxiContentPopulate
        }
      };
      break;

    case "footer":
      params = { populate: "*" };
      break;

    case "terms-and-policies":
      params = {
        sort: "id",
        fields: ["id", "title"],
        populate: seo
      };
      break;

    default:
      params = {
        sort: "id",
        populate: "*"
      };
  }

  try {
    const { data } = await api.get(url, { params });
    return data?.data ?? data;
  } catch (error) {
    console.error(
      `fetchLegends ERR -> ${url}`,
      error?.response?.status,
      error?.response?.data || error.message
    );
    throw error; // do NOT cache failures
  }
};
// params = {
//         populate: [
//           "seo",
//           "seo.shareImage",
//           "solutions",
//           "industries",
//           "section",
//           "type",
//           "vxiContent.images",
//         ]
//       };
export const fetchLegendByIdImpl = async (id, endpoint) => {
  const base = process.env.NEXT_PUBLIC_STRAPI_API_URL;

  if (!id || !endpoint) {
    throw new Error(`Missing id or endpoint: ${id}, ${endpoint}`);
  }

  const url = `${base}${endpoint}/${id}`;
  let params = {};

  switch (endpoint) {
    case "contents":
      params = {
        sort: "id",
        populate: {
          seo: {
            populate: ["shareImage"]
          },
          section: {
            populate: {
              awardsList: {
                populate: ["images"]
              },
              leadersList: {
                populate: ["profile"]
              },
              hero: true,
              button: true,
              images: true,
              announcements: {
                populate: ["images"]
              },
              floorPanel: {
                populate: ["images"]
              },
              metrics: true,
              vxi_contents: {
                populate: {
                  vxiContent: {
                    populate: [
                      "author",
                      "images",
                      "supportImages",
                      "author.authorImage"
                    ]
                  },
                  solutions: true,
                  industries: true,
                  section: true,
                  type: true
                }
              },
              embeddeds: true,
              embedded: true,
              seriesArrangement: true,
              borderedItems: {
                populate: ["images"]
              },
              sliderList: {
                populate: ["images"]
              },
              left: {
                populate: {
                  page: {
                    populate: {
                      section: {
                        populate: ["images"]
                      }
                    }
                  }
                }
              },
              right: {
                populate: {
                  page: {
                    populate: {
                      section: {
                        populate: ["images"]
                      }
                    }
                  }
                }
              },
              cxa_hub: {
                populate: {
                  industries: true,
                  // SEO component with its metaSocial inside
                  seo: {
                    populate: {
                      shareImage: true,
                      metaSocial: {
                        populate: ["image"]
                      }
                    }
                  },
                  shareImage: true,
                  speaker: {
                    populate: ["authorImage"]
                  },
                  topics: true,
                  series: true
                }
              }
            }
          }
        }
      };
      break;

    case "vxi-contents":
      params = {
        populate: [
          "seo",
          "seo.shareImage",
          "vxiContent",
          "vxiContent.author",
          "vxiContent.preBuiltAuthor",
          "vxiContent.preBuiltAuthor.authorImage",
          "vxiContent.customFields",
          "solutions",
          "industries",
          "section",
          "type",
          "vxiContent.images",
          "vxiContent.supportImages",
          "vxiContent.author.authorImage",
          "navigationSplit",
          "navigationSplit.left",
          "navigationSplit.right",
          "navigationSplit.left.page",
          "navigationSplit.right.page",
          "navigationSplit.left.page.section.images",
          "navigationSplit.right.page.section.images"
        ]
      };
      break;

    case "terms-and-policies":
      params = {
        populate: "*"
      };
      break;

    default:
      params = {
        populate: "*"
      };
  }

  try {
    const { data } = await api.get(url, { params });
    return data?.data ?? data;
  } catch (error) {
    console.error("fetchLegendById ERR ->", url, error?.response?.status, error?.response?.data || error.message);
    throw error; // do NOT cache failures
  }
};




export async function webhookBypass(payload) {
  const httpsAgent = new https.Agent({ rejectUnauthorized: false }); // SSL bypass for internal use only

  const response = await axios.post(
    'https://vxi.com/api/strapi-webhook/',
    payload,
    { httpsAgent }
  );

  return response.data;
}

export async function emailBypass(payload) {
  const httpsAgent = new https.Agent({ rejectUnauthorized: false }); // SSL bypass for internal use only

  const response = await axios.post(
    'https://web.vxi-internal.com/api/send-email',
    payload,
    { httpsAgent }
  );

  return response.data;
}

// export const getUserGeo = async () => {
//   try {
//     const response = await axios.get("https://ipwho.is/"); // no httpsAgent
//     return response.data; // e.g., "DE", "US"
//   } catch (error) {
//     console.error("Error fetching geolocation:", error);
//     return null;
//   }
// };

export const getUserGeo = async () => {
  if (typeof window === "undefined" || !navigator.geolocation) {
    return null;
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
          );
          const data = await res.json();

          let region = null, country = null, continent = null;
          if (data.results && data.results.length > 0) {
            const components = data.results[0].address_components;
            for (const comp of components) {
              if (comp.types.includes("administrative_area_level_1")) region = comp.short_name;
              if (comp.types.includes("country")) country = comp.short_name;
              // Google doesn't provide continent, you can map country to continent if needed
            }
            // Example mapping for continent (expand as needed)
            const continentMap = {
              "US": "NA", "CA": "NA", "DE": "EU", "FR": "EU", // etc.
            };
            continent = continentMap[country] || null;
          }

          resolve({
            region_code: region,
            country_code: country,
            continent_code: continent,
            latitude,
            longitude,
          });
        } catch (error) {
          console.error("Error fetching geocoding:", error);
          resolve(null);
        }
      },
      () => resolve(null),
      { timeout: 10000 }
    );
  });
};

// Fetch by URL or slug using POST to /api/search-contents/
export const fetchByUrlImpl = async (urlOrSlug) => {
  if (!urlOrSlug) {
    throw new Error(`Missing url or slug: ${urlOrSlug}`);
  }
  const cleanedInput = `${urlOrSlug}`.trim();
  const isAbsoluteUrl = /^https?:\/\//i.test(cleanedInput);
  const urlPath = isAbsoluteUrl ? cleanedInput : `/${cleanedInput.replace(/^\/+/, "")}`;

  const base = (process.env.NEXT_PUBLIC_STRAPI_API_URL || "").replace(/\/+$/, "");
  const path = "/search-contents";
  const url = `${base}${path}`;

  try {
    const { data } = await api.post(path, { url: urlPath });
    return data?.data ?? data;
  } catch (error) {
    const status = error?.response?.status;
    const body = error?.response?.data;
    console.error(
      `fetchByUrl ${status || "ERR"} -> ${url} slug="${urlPath}" ::`,
      typeof body === "string" ? body : JSON.stringify(body) || error.message
    );
    const err = new Error(`fetchByUrl ${status || "ERR"} for ${urlPath}`);
    err.status = status;
    err.slug = urlPath;
    throw err; // do NOT cache failures
  }
};

// Fetch What's New (no params required)
export const fetchWhatsNewImpl = async () => {
  const base = (process.env.NEXT_PUBLIC_STRAPI_API_URL || "").replace(/\/+$/, "");
  const path = "/whats-new";
  const url = `${base}${path}`;

  try {
    const { data } = await api.get(path);
    return data;
  } catch (error) {
    console.error(
      "fetchWhatsNew ERR ->",
      url,
      error?.response?.status,
      error?.response?.data || error.message
    );
    throw error; // do NOT cache failures
  }
};

// Fetch VXI contents by URL using POST to /api/search-vxi-contents
export const fetchVxiByUrlImpl = async (url, nextPage) => {
  if (!url) {
    throw new Error(`Missing url: ${url}`);
  }

  const base = (process.env.NEXT_PUBLIC_STRAPI_API_URL || "").replace(/\/+$/, "");
  const path = "/search-vxi-contents";
  const fullUrl = `${base}${path}`;

  try {
    const { data } = await api.post(path, { url, page: nextPage || 1 });
    return data;
  } catch (error) {
    console.error(
      "fetchVxiByUrl ERR ->",
      fullUrl,
      `url="${url}" page=${nextPage || 1}`,
      error?.response?.status,
      error?.response?.data || error.message
    );
    throw error; // do NOT cache failures
  }
};


// Fetch smart-search results using POST to /api/smart-search
export const fetchSmartSearchImpl = async (query) => {
  if (!query) {
    throw new Error(`Missing query: ${query}`);
  }

  const base = (process.env.NEXT_PUBLIC_STRAPI_API_URL || "").replace(/\/+$/, "");
  const path = "/smart-search";
  const fullUrl = `${base}${path}`;

  try {
    const { data } = await api.post(path, { query, threshold: .25 });
    return data;
  } catch (error) {
    console.error(
      "fetchSmartSearch ERR ->",
      fullUrl,
      `query="${query}"`,
      error?.response?.status,
      error?.response?.data || error.message
    );
    throw error; // do NOT cache failures
  }
};


// lib/api.js (or wherever createSitemap lives)
// lib/api.js (or wherever createSitemap lives)
export const createSitemap = async () => {
  const base = (process.env.NEXT_PUBLIC_STRAPI_API_URL || "").replace(/\/+$/, "");
  const path = "/sitemap.xml";
  const url = `${base}${path}`;

  try {
    const { data } = await api.get(path, {
      responseType: "text",
      transformResponse: [(d) => d],
    });
    return data; // always a string
  } catch (error) {
    console.error("URL:", url, error?.response?.data || error.message);
    // Return a minimal valid sitemap so the Response body stays a string.
    return `<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"></urlset>\n`;
  }
};

// =====================
// NEVER-EXPIRE SERVER CACHE (renew on CMS change only)
// Impls throw on failure so unstable_cache never memoizes errors.
// Wrappers return the legacy { error } shape. Bust via revalidateTag().
// =====================
const tagForEndpoint = (endpoint) => {
  const e = String(endpoint || "");
  if (["menus"].includes(e)) return STRAPI_TAGS.menus;
  if (["contents", "terms-and-policies"].includes(e)) return STRAPI_TAGS.contents;
  if (["footer"].includes(e)) return STRAPI_TAGS.footer;
  if (["vxi-contents"].includes(e)) return STRAPI_TAGS.vxi;
  if (["cxa-hubs"].includes(e)) return STRAPI_TAGS.hubs;
  return STRAPI_TAGS.misc;
};

const cachedFetchLegends = (endpoint) =>
  unstable_cache(
    (ep) => fetchLegendsImpl(ep),
    ["fetchLegends", String(endpoint)],
    {
      revalidate: false,
      tags: tagForEndpoint(endpoint),
    }
  )(endpoint);

const _cachedFetchPosts = (endpoint) =>
  unstable_cache(
    (ep) => fetchPostsImpl(ep),
    ["fetchPosts", String(endpoint)],
    {
      revalidate: false,
      tags: tagForEndpoint(endpoint),
    }
  )(endpoint);

const cachedFetchLegendById = (id, endpoint) =>
  unstable_cache(
    (i, ep) => fetchLegendByIdImpl(i, ep),
    ["fetchLegendById", String(endpoint), String(id)],
    {
      revalidate: false,
      tags: tagForEndpoint(endpoint),
    }
  )(id, endpoint);

const cachedFetchByUrl = (urlOrSlug) =>
  unstable_cache(
    (u) => fetchByUrlImpl(u),
    ["fetchByUrl", String(urlOrSlug)],
    {
      revalidate: false,
      tags: STRAPI_TAGS.pages,
    }
  )(urlOrSlug);

const cachedFetchWhatsNew = () =>
  unstable_cache(fetchWhatsNewImpl, ["fetchWhatsNew"], {
    revalidate: false,
    tags: STRAPI_TAGS.misc,
  })();

const safeCall = async (fn, args, label) => {
  try {
    return await fn(...args);
  } catch (err) {
    // Already logged inside the impl; return legacy shape so callers don't crash.
    return {
      error: `Failed to fetch ${label}.`,
      status: err?.status,
      slug: err?.slug,
    };
  }
};

export const fetchPosts = (endpoint) => safeCall(_cachedFetchPosts, [endpoint], "posts");
export const fetchLegends = (endpoint) => safeCall(cachedFetchLegends, [endpoint], "legends");
export const fetchLegendById = (id, endpoint) => safeCall(cachedFetchLegendById, [id, endpoint], "legend");
export const fetchByUrl = (urlOrSlug) => safeCall(cachedFetchByUrl, [urlOrSlug], "page");
export const fetchBySlug = fetchByUrl;
export const fetchWhatsNew = () => safeCall(cachedFetchWhatsNew, [], "what's new");
export const fetchVxiByUrl = (...args) => safeCall(fetchVxiByUrlImpl, args, "vxi contents");

// QueryClient-backed helpers: server components prefetch into a per-request
// client, then dehydrate into the persistent browser cache.
export async function prefetchPosts(queryClient, endpoint) {
  return queryClient.prefetchQuery({
    queryKey: ["posts", endpoint],
    queryFn: () => cachedFetchLegends(endpoint),
  });
}
export async function getPosts(queryClient, endpoint) {
  return queryClient.fetchQuery({
    queryKey: ["posts", endpoint],
    queryFn: () => cachedFetchLegends(endpoint),
  });
}
export async function getAllPosts(endpoint) {
  return _cachedFetchPosts(endpoint);
}


